<p-confirmDialog header="Lose Rich Formatting?" [key]="guid" icon="pi pi-exclamation-triangle"></p-confirmDialog>

<div id="rich-text-toggle" *ngIf="showRichTextToggle">
	<label>
		<i class="pi pi-question-circle p-mr-2" tooltipPosition="left"
			pTooltip="Enables text to be styled with rich formatting. Insert images by drag and drop, copy/paste, or clicking the image button on the toolbar.">
		</i>

		Rich Text

		<p-inputSwitch class="p-d-flex p-ml-2" [ngModel]="useRichText" (onChange)="onUseRichTextToggled($event)"></p-inputSwitch>
	</label>
</div>

<ng-container [ngSwitch]="editorType">
	<p-editor #pEditor *ngSwitchCase="'Rich'" [modules]="quillModules" [style.width]="editorWidth" [style]="{'min-height': editorHeight}"
		[placeholder]="placeholder"
		(onInit)="onQuillInit($event.editor)" [(ngModel)]="model" (ngModelChange)="onModelChanged()">
		
		<ng-template pTemplate="header">
			<span class="ql-formats">
				<select class="ql-font"></select>
				<select class="ql-size"></select>
			</span>

			<span class="ql-formats">
				<button class="ql-bold" title="Bold ({{modifierKey}}+B)"></button>
				<button class="ql-italic" title="Italic ({{modifierKey}}+I)"></button>
				<button class="ql-underline" title="Underline ({{modifierKey}}+U)"></button>
				<button class="ql-strike" title="Strikethrough"></button>
				<select class="ql-align"></select>
			</span>

			<span class="ql-formats">
				<select class="ql-color"></select>
				<select class="ql-background"></select>
			</span>

			<span class="ql-formats">
				<button class="ql-script" value="sub" title="Subscript"></button>
				<button class="ql-script" value="super" title="Superscript"></button>
				<button class="ql-blockquote" title="Blockquote"></button>
			</span>

			<span class="ql-formats">
				<button class="ql-list" value="ordered" title="Numbered List"></button>
				<button class="ql-list" value="bullet" title="Bulleted List"></button>
			</span>

			<span class="ql-formats">
				<button class="ql-indent" value="-1" title="Indent Left"></button>
				<button class="ql-indent" value="+1" title="Indent Right"></button>
			</span>

			<span class="ql-formats">
				<button class="ql-link" title="Link"></button>
				<button class="ql-image" title="Embed Image"></button>
			</span>

			<span class="ql-formats">
				<button class="ql-clean" title="Clear Selected Formatting"></button>
			</span>
		</ng-template>
	</p-editor>

	<input *ngSwitchCase="'TextInput'" id="text-input" class="text-input-entry" autocomplete="on" type="text" pInputText [attr.name]="name || ''"
		[style.width]="editorWidth" [(ngModel)]="model" (ngModelChange)="onModelChanged()" />

	<textarea *ngSwitchCase="'TextArea'" id="text-area" class="text-area-entry" autocomplete="off" type="text" pInputTextarea [attr.name]="name || ''"
		[rows]="height" [style.width]="editorWidth"
		[(ngModel)]="model" (ngModelChange)="onModelChanged()">
	</textarea>
</ng-container>

<div *ngIf="useAcceptRejectButtons" class="p-mt-2">
	<p-button icon="pi pi-check p-text-bold" (click)="onAcceptClicked()" title="Save Edit"></p-button>

	<p-button icon="pi pi-times p-text-bold" (click)="onRejectClicked()" title="Cancel Edit"
		styleClass="p-ml-2 p-button-secondary">
	</p-button>
</div>